export default __webpack_public_path__ + "static/media/tutorial-pc_3.84584064.svg";